import React, { useContext } from 'react';
import m5 from '../../Assets/52.avif'
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthProvider';

function Admin() {
    const {user, logOut} = useContext(AuthContext);
  return (
    <div className="hero min-h-screen" style={{ backgroundImage: `url(${m5})`, height:"900px" }}>
  <div className="hero-overlay bg-opacity-60"></div>
  <div className="hero-content text-center text-neutral-content">
    <div className="max-w-md">
      <h1 className="mb-5 text-5xl font-bold">Hello Admin</h1>
      <p className="text-2xl mb-5">Please, Post your data in your specific section.</p>
      <div style={{display:'flex', flexDirection:'column'}}>
        <Link to='/postCertificate'><button class="btn btn-info text-white">Post Certificate Info</button></Link>
        <Link to='/postSchool'><button class="btn btn-success text-white my-6">Post School Info</button></Link>
        <Link to='/postCollege'><button class="btn btn-warning text-white">Post College Info</button></Link>
        <Link to='/postUniversity'><button class="btn btn-secondary text-white my-6">Post University Info</button></Link>
        <Link to='/postDiffServices'><button class="btn btn-primary text-white">Post Services Info</button></Link>
        {
            user?.email === 'pabelmahbub@gmail.com' &&
         <div  className='mt-6'>

            <Link to='/manageCertificate'><button class="btn btn-error mr-4 text-white">Delete Certificate Info</button></Link>
            <Link to='/manageSchool'><button class="btn btn-error text-white my-4">Delete School Info</button></Link>
            <Link to='/manageCollege'><button class="btn btn-error text-white mr-4">Delete College Info</button></Link>
            <Link to='/manageUniversity'><button class="btn btn-error text-white my-4">Delete University Info</button></Link>
            <Link to='/manageCareer'><button class="btn btn-error text-white">Delete Career Info</button></Link>
        </div>
        }
      </div>
        
    </div>
  </div>
</div>
   
                    
                   
                
  )
}

export default Admin